jQuery(document).ready(function ($) {
  if ($('.js-carousel-pc4sp2')[0]) {
    $('.js-carousel-pc4sp2').slick({
      dots: true,
      speed: 200,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },{
        breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '15px',
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          }
        }
      ]
    });
  }
  $(".read-more").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
  $('.f1-nav_item').each(function (i) {
    if (i == 0) {
      var target = $(this).attr("data-target"),
      targetId = $(target);

      $(this).addClass('active');
      $(this).add(targetId).addClass('active');
    }

    $(this).click(function () {
      var target = $(this).attr("data-target"),
        targetId = $(target);
      $('.f1-nav_item,.tab-pane').removeClass('active');
      $(this).add(targetId).addClass('active');
    });
  });
});
objectFitImages('img.object_fit_img');
